/**
 * Mirrors the nuxt UK display logic from helpers/search/location/searchLocationHelper.ts.
 * On UK the suburb field holds the outward code (outcode), which must be displayed last ("Leeds, LS10").
 * Initial (non-hash) search results may carry override_area_name_from_request — the area name from the
 * requested URL — which replaces the city part; when both suburb and the override are outcodes,
 * the city takes the suburb slot so an outcode is not shown twice.
 */
export function getUserLocationForSearchUnitedKingdom(user) {
    if (typeof window !== 'undefined' && window.location.hash) {
        return joinUnitedKingdomLocations([_.get(user, 'suburb'), _.get(user, 'city')]);
    }

    const suburb = _.get(user, 'suburb', '');
    const city = _.get(user, 'city', '');
    const overrideAreaName = _.get(user, 'override_area_name_from_request', '');

    let displayCity = city;
    if (overrideAreaName) {
        displayCity = overrideAreaName;
    }

    let displaySuburb = suburb;
    if (suburb && overrideAreaName && isUkOutwardCode(suburb) && isUkOutwardCode(overrideAreaName)) {
        displaySuburb = city;
    }

    return joinUnitedKingdomLocations(_.uniq([displayCity, displaySuburb]));
}

function joinUnitedKingdomLocations(locations) {
    return locations
        .filter(function (location) {
            return !!location;
        })
        .sort(function (a, b) {
            if (isUkOutwardCode(b)) {
                return -1;
            }

            return 1;
        })
        .join(', ');
}

/**
 * Regular expression for UK outward code aka Outcode
 * example: valid NG1, NG80A
 * example: invalid HOP1
 */
export function isUkOutwardCode(code) {
    const pattern = /^[A-Z]{1,2}\d{1,2}[A-Z]?$/i;

    return pattern.test(code);
}
